import {hframe, vframe} from '@xh/hoist/cmp/layout';
import {creates, hoistCmp} from '@xh/hoist/core';
import {panel} from '@xh/hoist/desktop/cmp/panel';
import {positions} from './impl/positions/Positions';
import {watchlist} from './impl/watchlist/WatchlistPanel';
import {PortfolioTabModel} from './PortoflioTabModel';
import {portfolio} from './impl/portfolio/Portfolio';
import {workingOrdersPanel} from './impl/orders/WorkingOrders';
import {Icon} from '@xh/hoist/icon';

export const portfolioTab = hoistCmp.factory<PortfolioTabModel>({
    model: creates(PortfolioTabModel),
    render({model}) {
        return hframe(leftPanel(), rightPanel());
    }
});

const leftPanel = hoistCmp.factory<PortfolioTabModel>(({model}) =>
    panel({
        modelConfig: {
            defaultSize: 230,
            side: 'left',
            persistWith: {prefKey: 'portfoliosTabState', path: 'leftPanelSize'},
            collapsible: true,
            resizable: true
        },
        compactHeader: true,
        title: 'Portfolios',
        icon: Icon.portfolio(),
        item: vframe(portfolio({model: model.portfolioModel}), watchlist({model: model.watchlistModel}))
    })
);

const rightPanel = hoistCmp.factory<PortfolioTabModel>(({model}) =>
    panel({
        item: vframe(positionsPanel({model: model.positionsModel}), workingOrdersPanel({model: model.workingOrdersModel}))
    })
);

const positionsPanel = hoistCmp.factory(() =>
    panel({
        compactHeader: true,
        item: positions()
    })
);
